import useAuthStore from "../store/auth";

function createApiClient({ baseUrl, defaultHeaders = {} }) {
  async function request(method, endpoint, data = null, customOptions = {}) {
    const url = baseUrl + endpoint;

    const { getState } = useAuthStore;
    const token = getState().userInfo?.accessToken;

    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...defaultHeaders,
        ...customOptions.headers,
      },
      ...customOptions,
    };

    if (data) {
      if (method === "GET") {
        const params = new URLSearchParams(data).toString();
        return fetch(url + "?" + params, options).then(handleResponse);
      } else {
        options.body = JSON.stringify(data);
      }
    } 

    return fetch(url, options).then(handleResponse);
  }

  function handleResponse(res) {
    if (!res.ok) {
      return res.json().then((err) => {
        throw err;
      });
    }
    return res.json();
  }

  return {
    get: (url, params, options) => request("GET", url, params, options),
    post: (url, data, options) => request("POST", url, data, options),
    put: (url, data, options) => request("PUT", url, data, options),
    delete: (url, data, options) => request("DELETE", url, data, options),
    patch: (url, data, options) => request("PATCH", url, data, options),
  };
}

const apiClient = createApiClient({
  baseUrl: "https://libra-api-dev.zhilingtech.com",
});

export default apiClient;
